<app-loading-indicator
  *ngIf="
    !stateManagerProjectService.isViewerLoaded ||
    (isProcessOfResetChanges() | async)
  "
></app-loading-indicator>
<app-content-splitter
  [order]="order"
  [(view)]="stateManagerProjectService.viewMode"
  (viewChange)="onViewChanged()"
>
  <div
    class="dicom-image-container"
    #firstViewWindow
    [ngClass]="{
      'selected-item':
        stateManagerProjectService.currentSelectedWindow ===
        ViewWindowIndex.Coronal
    }"
    (click)="selectWindow(1, $event, firstViewWindow)"
    (contextmenu)="openContextMenu($event, firstViewWindow)"
  >
    <app-loading-indicator
      *ngIf="isProcessOfShowDiffHide(1)"
    ></app-loading-indicator>
    <ng-container
      *ngTemplateOutlet="
        dicomImageHeader;
        context: { currentView: viewNames[0], currentSelectedView: 1 }
      "
    ></ng-container>
    <div
      id="viewer1"
      class="dicom-image"
      [ngClass]="{
        'not-selected-viewer-item':
          stateManagerProjectService.currentSelectedWindow !==
          ViewWindowIndex.Coronal
      }"
    ></div>
  </div>
  <div
    class="dicom-image-container"
    #forthViewWindow
    [ngClass]="{
      'selected-item':
        stateManagerProjectService.currentSelectedWindow ===
        ViewWindowIndex.Model3D
    }"
    (click)="selectWindow(4, $event, forthViewWindow)"
    (contextmenu)="openContextMenu($event, forthViewWindow)"
  >
    <app-loading-indicator
      *ngIf="occViewerService.isViewerLoading"
    ></app-loading-indicator>
    <ng-container
      *ngTemplateOutlet="
        dicomImageHeader;
        context: { currentView: viewNames[1], currentSelectedView: 4 }
      "
    ></ng-container>
    <div
      id="viewer-OCC"
      class="dicom-image"
      [ngClass]="{
        'not-selected-viewer-item':
          stateManagerProjectService.currentSelectedWindow !==
          ViewWindowIndex.Model3D
      }"
    >
      <app-occ-viewer></app-occ-viewer>
    </div>
  </div>
  <div
    class="dicom-image-container"
    #secondViewWindow
    [ngClass]="{
      'selected-item':
        stateManagerProjectService.currentSelectedWindow ===
        ViewWindowIndex.Axial
    }"
    (click)="selectWindow(2, $event, secondViewWindow)"
    (contextmenu)="openContextMenu($event, secondViewWindow)"
  >
    <app-loading-indicator
      *ngIf="isProcessOfShowDiffHide(2)"
    ></app-loading-indicator>
    <ng-container
      *ngTemplateOutlet="
        dicomImageHeader;
        context: { currentView: viewNames[2], currentSelectedView: 2 }
      "
    ></ng-container>
    <div
      id="viewer2"
      class="dicom-image"
      [ngClass]="{
        'not-selected-viewer-item':
          stateManagerProjectService.currentSelectedWindow !==
          ViewWindowIndex.Axial
      }"
    ></div>
  </div>
  <div
    class="dicom-image-container"
    #thirdViewWindow
    [ngClass]="{
      'selected-item':
        stateManagerProjectService.currentSelectedWindow ===
        ViewWindowIndex.Sagittal
    }"
    (click)="selectWindow(3, $event, thirdViewWindow)"
    (contextmenu)="openContextMenu($event, thirdViewWindow)"
  >
    <app-loading-indicator
      *ngIf="isProcessOfShowDiffHide(3)"
    ></app-loading-indicator>
    <ng-container
      *ngTemplateOutlet="
        dicomImageHeader;
        context: { currentView: viewNames[3], currentSelectedView: 3 }
      "
    ></ng-container>
    <div
      id="viewer3"
      class="dicom-image"
      [ngClass]="{
        'not-selected-viewer-item':
          stateManagerProjectService.currentSelectedWindow !==
          ViewWindowIndex.Sagittal
      }"
    ></div>
  </div>
</app-content-splitter>

<ng-template
  #dicomImageHeader
  let-currentView="currentView"
  let-currentSelectedView="currentSelectedView"
>
  <div class="image-topic">
    <div>
      <div class="dicom-image-header">
        <select
          #select
          class="dicom-image-header-select"
          [ngModel]="currentView"
          (ngModelChange)="onViewSelected($event, currentView, select)"
        >
          <option *ngFor="let viewName of viewNames" [value]="viewName">
            <span>
              {{ viewName }}
            </span>
          </option>
        </select>
        <span
          class="dicom-image-header-edit font-16"
          *ngIf="
            stateManagerProjectService.currentSelectedWindow ===
            currentSelectedView
          "
        >
          Active
        </span>
      </div>
      <div *ngIf="currentSelectedView !== 4" class="slice-counter font-16">
        <span> Slice: {{ getSlicesInfo(currentSelectedView) }}</span>
      </div>
    </div>
    <div class="control-view-buttons">
      <div
        class="full-size-button"
        (click)="openFullsizeMode(currentSelectedView, $event)"
      >
        <mat-icon
          class="control-view-button"
          [svgIcon]="
            stateManagerProjectService.viewMode !== 1
              ? 'full-size'
              : 'small-size'
          "
        >
        </mat-icon>
      </div>
      <ng-container
        *ngTemplateOutlet="
          currentView === '3D Model' ? viewerButtons : commonButtons;
          context: { currentSelectedView: currentSelectedView }
        "
      >
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #centerOfToolbarContent>
  <mat-divider [vertical]="'true'"></mat-divider>
  <div class="controls">
    <app-button-icon
      class="toolbar-icon-button"
      [action]="fourViewsAction"
      [disabled]="!(stateManagerProjectService.isViewerLoaded$ | async)"
      [active]="stateManagerProjectService.viewMode === 4"
      matTooltip="{{ 'viewer.Tools.FourViews' | translate }}"
      [matTooltipPosition]="'below'"
    >
    </app-button-icon>
    <app-button-icon
      class="toolbar-icon-button"
      [action]="singleViewAction"
      [disabled]="!(stateManagerProjectService.isViewerLoaded$ | async)"
      [active]="stateManagerProjectService.viewMode === 1"
      matTooltip="{{ 'viewer.Tools.SingleView' | translate }}"
      [matTooltipPosition]="'below'"
    >
    </app-button-icon>
    <app-button-icon
      class="toolbar-icon-button"
      [action]="twoViewsAction"
      [disabled]="!(stateManagerProjectService.isViewerLoaded$ | async)"
      [active]="stateManagerProjectService.viewMode === 2"
      matTooltip="{{ 'viewer.Tools.TwoViews' | translate }}"
      [matTooltipPosition]="'below'"
    >
    </app-button-icon>
  </div>
  <mat-divider [vertical]="'true'"></mat-divider>
  <app-reset-views-tool></app-reset-views-tool>
  <mat-divider [vertical]="'true'"></mat-divider>
  <app-image-slider></app-image-slider>
  <app-colors-menu></app-colors-menu>
</ng-template>

<ng-template #commonButtons let-currentSelectedView="currentSelectedView">
  <mat-icon
    class="control-view-button"
    [svgIcon]="'move-model'"
    [ngClass]="{
      'activated-control-view-button':
        ((stateManagerProjectService.currentTool$ | async) === 'Pan' || isPanToolSelectedByMmb) &&
        stateManagerProjectService.currentSelectedWindow === currentSelectedView
    }"
    (click)="activatePanTool()"
  >
  </mat-icon>
  <mat-icon
    class="control-view-button"
    [svgIcon]="'zoom-model'"
    [ngClass]="{
      'activated-control-view-button':
        (stateManagerProjectService.currentTool$ | async) === 'Zoom' &&
        stateManagerProjectService.currentSelectedWindow === currentSelectedView
    }"
    (click)="activateZoomTool()"
  >
  </mat-icon>
</ng-template>

<ng-template #viewerButtons let-currentSelectedView="currentSelectedView">
  <mat-icon
    class="control-view-button"
    [svgIcon]="'move-model'"
    [ngClass]="{
      'disabled-control-view-button':
        stateManagerProjectService.is3dUpdateNeeded,
      'activated-control-view-button': is3dMoveEnabled() || is3dPanToolSelectedByMmb
    }"
    (click)="occViewerService.toggleTool('pan')"
  >
  </mat-icon>
  <mat-icon
    class="control-view-button"
    [svgIcon]="'rotate-model'"
    [ngClass]="{
      'disabled-control-view-button':
        stateManagerProjectService.is3dUpdateNeeded,
      'activated-control-view-button': is3dRotateEnabled()
    }"
    (click)="occViewerService.toggleTool('rotation')"
  >
  </mat-icon>
  <mat-icon
    class="control-view-button"
    [svgIcon]="'zoom-model'"
    [ngClass]="{
      'disabled-control-view-button':
        stateManagerProjectService.is3dUpdateNeeded,
      'activated-control-view-button': is3dZoomEnabled()
    }"
    (click)="occViewerService.toggleTool('zoom')"
  >
  </mat-icon>
</ng-template>
